import React from 'react';
import SubscribedComponent from '../components/subscribed_component.js';
import WreckAPI from '../lib/wreck_api.js';

class PurchasePending extends SubscribedComponent {
  state = {loading: false, permissions: [], subscriptionExpirations: {}, claims: {} }

  componentWillMount(){
    const params = this.props.match.params

    WreckAPI.purchase({purchase_provider: 'stripe', transaction_info: {session_id: params.id}})
      .then(data => {
        this.props.history.push('/welcome')
      })
      .catch(data => {
        alert(`We are very sorry, an error occurred during payment. Please try again later. ${JSON.stringify(data)}`);
        this.props.history.push('/buy')
      })
  }

  render() {
    return ""
  }
}

export default PurchasePending;



// WEBPACK FOOTER //
// ./src/pages/purchase_pending.js